/* eslint-disable no-param-reassign */
import filter from 'lodash/filter';
import reduce from 'lodash/reduce';
import React, { Component } from 'react';
import { ReactReduxContext } from 'react-redux';

import GoldenComponent from '../HighOrderComponents/GoldenComponent';

import layoutBuilder from './layoutBuilder';

type Props = {
  // import { exerciseTypes } from '../ExerciseHandler/ExerciseHandler';
  exercise?: any; // TODO: PropTypes.shape(exerciseTypes)
  startSession: (...args: any[]) => any;
};

class BaseLayout extends Component<Props> {
  componentDidMount() {
    switch (this.props.exercise.type) {
      case 'TabExercise':
      case 'BulletExercise':
        break;
      default:
        this.props.startSession(false);
        break;
    }
  }

  render() {
    const { exercise } = this.props;
    const builder = layoutBuilder(exercise.type);

    const config = builder({ ...this.props });

    // @ts-expect-error ts-migrate(7024) FIXME: Function implicitly has return type 'any' because ... Remove this comment to see the full error message
    const isContentEmpty = (item: any) => {
      if (item.content) {
        return reduce(
          item.content,
          (acc, contentItem) => acc && isContentEmpty(contentItem),
          true,
        );
      }
      return false;
    };

    const filterEmptyContent = (item: any) => {
      if (item.content) {
        item.content = filter(
          item.content,
          (contentItem) => !isContentEmpty(filterEmptyContent(contentItem)),
        );
      }
      return item;
    };

    filterEmptyContent(config);
    return (
      // We have to inject the store in order to create a Provider for each Golden layout item
      <ReactReduxContext.Consumer>
        {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'config' does not exist on type 'Intrinsi... Remove this comment to see the full error message */}
        {({ store }: any) => <GoldenComponent config={config} store={store} />}
      </ReactReduxContext.Consumer>
    );
  }
}

export default BaseLayout;
